module.exports = __webpack_public_path__ + "img/info-circle.f0b4e155.svg";